import React, { useRef } from 'react';
import { Stack, Avatar, IconButton } from '@mui/material';
import DragDropUpload from '../../../Components/DragDropUpload';
import employeeUploadImg from '../../../Assets/Image/employeeUpload.svg';
import { AppColors } from '../../../Utils/helper/AppColors';
import { CloseIcon } from '../../../Components/Icons/Icons';

const EmployeesEmptyView = ({ handleImport, noBorderIcon = false, isModel = false, onClose }) => {
	const fileRef = useRef();
	// Drag and drop handlers for the modal
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
		        console.log('Dropped files outside the component');

        const file = e.dataTransfer.files[0];
        if (file) {
            handleImport({ target: { files: [file] } });
        }
    };

	return (
		<Stack
			position="relative"
			direction="column"
			alignItems="center"
			justifyContent="center"
			my="auto"
			gap={2}
			 onDragOver={handleDragOver}
            onDrop={handleDrop}
			sx={
				isModel
					? {
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							background: '#fff',
							borderRadius: 2,
							boxShadow: 3,
							p: 4,
							minWidth: '90vw',
							minHeight: '90vh',
					  }
					: {}
			}
		>
			{isModel && (
				<IconButton
					onClick={onClose}
					size="small"
					sx={theme => ({
						position: 'absolute',
						top: 8,
						right: 8,
						zIndex: 1,
						color: theme.palette.primary.darker_primary,
					})}
				>
					<CloseIcon />
				</IconButton>
			)}
			{/* Image with click and drop functionality */}
			<Stack
				// onClick={() => fileRef.current.click()}
				// onDrop={(e) => {
				// 	e.preventDefault();
				// 	e.stopPropagation();
				// 	console.log('File dropped: running...');
				// 	const file = e.dataTransfer.files[0];
				// 	if (file) {
				// 		handleImport({ target: { files: [file] } });
				// 	}
				// }}
				// sx={{
				// 	width: isModel ? '374px' : '598px',
				// 	height: isModel ? '248px' : '396px',
				// 	cursor: 'pointer',
				// }}
			>
				<Avatar
					src={employeeUploadImg}
					alt="Upload Illustration"
					sx={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 0 }}
				/>
			</Stack>

			{/* DragDropUpload Component */}
			<DragDropUpload
				fileRef={fileRef}
				onClose={onClose}
				dragDrop={false}
				noBorderIcon={noBorderIcon}
				isModel={isModel}
				subText="CSV, XSLS or XLS (max. 50 mb)"
				sampleFile="sample_user.xlsx"
				onUpload={handleImport}
				extra="While entering the details in excel file, please ensure that the phone numbers are added with the country code and time zone to be picked from the list of time zones mentioned in the excel sheet."
			/>
		</Stack>
	);
};

export default EmployeesEmptyView;
